import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="custom-footer">

      <div className="mb-3">

        <Link to="/">
          Home
        </Link>

        <Link to="/about-us">
          About
        </Link>

        <Link to="/privacy-policy">
          Privacy Policy
        </Link>

        <Link to="/contact-us">
          Contact
        </Link>

        <Link to="/terms-conditions">
          Terms
        </Link>

      </div>

      <p>
        © 2026 Free Online Tools
      </p>

    </footer>
  );
}